export default function PublicFooter() {
  return (
    <footer className="border-t border-border py-8 mt-8">
      <div className="container mx-auto px-4 text-center">
        {/* Legal links */}
        <div className="flex flex-wrap gap-4 justify-center text-sm text-muted-foreground mb-4">
          <a href="/terms" className="hover:text-primary transition-colors">
            Användarvillkor
          </a>
          <span>•</span>
          <a href="/privacy" className="hover:text-primary transition-colors">
            Integritetspolicy
          </a>
          <span>•</span>
          <a href="/cookies" className="hover:text-primary transition-colors">
            Cookiepolicy
          </a>
          <span>•</span>
          <a href="/community-guidelines" className="hover:text-primary transition-colors">
            Communityregler
          </a>
          <span>•</span>
          <a href="/pricing" className="hover:text-primary transition-colors">
            Prisplaner
          </a>
        </div>

        {/* Copyright */}
        <p className="text-xs text-muted-foreground">
          &copy; {new Date().getFullYear()}{' '}
          <a
            href="/about"
            className="hover:text-primary transition-colors underline-offset-2 hover:underline"
          >
            Beredskapshubben Norden AB
          </a>
          <span className="mx-1">•</span>
          Alla rättigheter förbehållna.
        </p>
      </div>
    </footer>
  );
}
